import { Space, Typography } from "antd";
import { AddFinanceCostsDrawer } from "components/Drawers/AddFinanceCostsDrawer/AddFinanceCostsDrawer.tsx";
import { DetailFinancePenaltyDrawer } from "components/Drawers/Finance/DetailFinancePenaltyDrawer.tsx";
import { data, DataItem } from "components/Tables/FinancePenaltiesTable/mock.ts";
import { Table } from "components/UI/Table";
import { TableColumnType } from "components/UI/Table/types/table.ts";
import { ColumnHeaderTitle } from "components/UI/Table/UI/ColumnHeaderTitle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useRowHandlers } from "hooks/useTableRowHandlers.tsx";
import { useState } from "react";
import Flag from "react-world-flags";
import { PermissionEnum } from "types/enums";
import { DrawerId, TableId } from "types/models.ts";

import PaginationResponse = App.Http.Responses.PaginationResponse;

interface FinancePenaltiesResponse {
    penalties: DataItem[];
    pagination: PaginationResponse;
}

export const FinancePenaltiesTable = () => {
    const { t } = usePaldockTranslation("tables.finance-penalties");
    const { t: tG } = usePaldockTranslation("tables.general-columns");
    const tableId = TableId.FinancePenaltiesTable;
    const [tableData, setTableData] = useState<DataItem[]>(data);

    const handleAddFinance = (newItem: DataItem) => {
        setTableData((prevData) => [...prevData, newItem]);
    };

    const mockData: FinancePenaltiesResponse = {
        penalties: tableData,
        pagination: {
            currentPage: 1,
            perPage: 30,
            total: 1,
            totalPages: 1,
            previousPage: null,
            nextPage: null,
            from: 1,
            to: 1,
            maxResults: 1000,
        },
    };
    const mockResponse = {
        data: mockData,
    };

    const { getRowHandlers, getRowClassName } = useRowHandlers<DataItem>({
        actions: [
            {
                type: "drawer",
                drawerId: DrawerId.DetailFinanceCost,
                permission: PermissionEnum.FinancePenaltyView,
                drawerParam: `${DrawerId.ParentField}-costId`,
            },
        ],
    });

    const columnConfig: TableColumnType<DataItem>[] = [
        {
            title: <ColumnHeaderTitle columnTitle={tG("date")} />,
            dataIndex: "datum",
            key: "datum",
            // TODO - BE allow sort
            // sorter: true,
        },
        {
            title: <ColumnHeaderTitle columnTitle={t("columns.user")} />,
            dataIndex: "uzivatel",
            key: "uzivatel",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("country")} />,
            dataIndex: "flagCode",
            key: "flagCode",
            render: (text) => (
                <Space>
                    <Flag code={text} className={"h-[13px] rounded-[3px]"} />
                </Space>
            ),
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("category")} />,
            dataIndex: "kategorie",
            key: "kategorie",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("offer")} />,
            dataIndex: "nabidka",
            key: "nabidka",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("type")} />,
            dataIndex: "typ",
            key: "typ",
        },
        {
            title: <ColumnHeaderTitle columnTitle={tG("id")} />,
            dataIndex: "id",
            key: "id",
            align: "right",
        },
        {
            title: <ColumnHeaderTitle columnTitle={t("columns.reward")} />,
            dataIndex: "odmena",
            key: "odmena",
            align: "right",
        },
        {
            title: <ColumnHeaderTitle columnTitle={t("columns.amount")} />,
            dataIndex: "castka",
            key: "castka",
            align: "right",
            render: (text) => <Typography.Text>${text}</Typography.Text>,
        },
    ];

    return (
        <>
            <AddFinanceCostsDrawer handleAdd={handleAddFinance} />
            <DetailFinancePenaltyDrawer />
            <Table<FinancePenaltiesResponse, DataItem>
                tableId={tableId}
                data={mockResponse.data}
                dataSource={mockResponse.data.penalties}
                columnConfig={columnConfig}
                rowKey={(record) => record.id}
                addEntityData={{
                    drawerId: DrawerId.AddFinanceCost,
                }}
                showRefetchButton={true}
                onRow={(record, rowIndex) => getRowHandlers(record, rowIndex)}
                rowClassName={(_, rowIndex) => getRowClassName(rowIndex)}
            />
        </>
    );
};
